import React from 'react';
import { Provider } from 'react-redux';
import PropTypes from 'prop-types';

import { TradeRadioLoader } from './TradeRadioLoader';

export const TradeRadioProvider = ({ store, data }) => {
    return (
        <Provider store={store}>
            <TradeRadioLoader {...data} />
        </Provider>
    );
};

TradeRadioProvider.propTypes = {
    store: PropTypes.object.isRequired,
    data: PropTypes.object
};
